module.exports = __webpack_public_path__ + "static/fonts/FaktSoftPro-Normal.f054c847.woff2";